module.exports = __webpack_public_path__ + "static/b2Res1-7d2bfece4bd505e0971583232ff192ae.png";